import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M28.608 11.246 16 2.614 3.392 11.246 16 19.877zM16 21.803 4.871 14.465 3.392 16 16 24.631 28.608 16l-1.499-1.568zm0 4.756L4.871 19.221l-1.479 1.535L16 29.387l12.608-8.631-1.499-1.568z" }, null, -1)
  ]))]))
}
export default { render: render }